module.exports = __webpack_public_path__ + "media/images/rie-plan-dceca642.png";